import { localeString } from '@/config/helpers.js'

export function getProductTypeLabel(personalized) {
  if (personalized) return 'Personalizado'
  else return 'Geral'
}

export function getProductFormatTypeLabel(type) {
  switch (type) {
    case 'general':
    case 'offer_sales':
      return 'Desconto Absoluto'
    case 'takepay':
    case 'takepay_offer_sales':
      return 'Leve & pague'
    case 'percentage':
    case 'percentage_offer_sales':
      return 'Desconto Percentual'
    case 'dynamic_pricing_percentage':
      return 'Desconto Percentual Por Loja'
    case 'dynamic_pricing_percentage_offer_sales':
      return 'Desconto Percentual Por Loja'
    case 'combo_offer_sales':
    case 'combo':
      return 'Combo'
    case 'cashback_percentage':
      return 'Cashback Percentual'
    case 'cashback_absolute':
    case 'cashback_absolute_offer_sales':
      return 'Cashback Absoluto'
    case 'points_offer_sales':
    case 'points':
      return 'Pontos'
    case 'dynamic_rule':
    case 'dynamic_rule_offer_sales':
      return 'Compre e Ganhe'
    case 'next_buy_cashback':
    case 'nextbuycashback':
    case 'next_buy_cashback_offer_sales':
      return 'Cashback'
    case 'cross_sell':
    case 'crosssell':
    case 'cross_sell_offer_sales':
      return 'Cross Sell'
    case 'benefits':
    case 'benefits_offer_sales':
      return 'Zé Compensa'
    default:
      break
  }
}

export function getItemDiscountLabel(item) {
  const { type, price, discounted_price, take, pay } = item
  switch (type) {
    case 'general':
      return `De R$${localeString(price, 2)} por R$${localeString(discounted_price, 2)}`
    case 'takepay':
      return `Leve ${take} pague ${pay}`
    case 'combo':
      return 'Combo'
    case 'percentage':
      return 'Desconto em porcentagem'
    default:
      return ''
  }
}
